import { getAccessLevelItems } from "@components/access-level/access-level-utils";
import { getCustomDateFilterOptions, getRecentDateFilterOptions } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { PROJECTS_ACCESS_LEVEL_FILTER_COLUMN, PROJECTS_SIZE_FILTER_COLUMN } from "@components/projects/projects-filters/projects-filter-constants";
import { getCustomSizeFilterOptions, getProjectsSizeFilterPresets } from "@components/projects/projects-filters/projects-size-filter-utils";
/**
 * Returns the filter options of the column. The dates, date ranges and size ranges the user picks
 * are options of their own, so the ones among the given filter IDs are included too.
 */
export function getProjectsFilterOptions(column, filterIds) {
  if (column === PROJECTS_ACCESS_LEVEL_FILTER_COLUMN) {
    return getProjectsAccessLevelFilterOptions();
  }
  if (column === PROJECTS_SIZE_FILTER_COLUMN) {
    return {
      ...getProjectsSizeFilterPresets(),
      ...getCustomSizeFilterOptions(filterIds)
    };
  }
  return {
    ...getProjectsCreatedFilterPresets(),
    ...getCustomDateFilterOptions(filterIds, getProjectCreatedTime)
  };
}

/** Returns a filter option for each of the access levels a project can have */
export function getProjectsAccessLevelFilterOptions() {
  return Object.fromEntries(getAccessLevelItems("project").map(({
    value,
    label
  }) => [value, {
    id: value,
    label,
    hasEntityPassedFilter: project => project.accessLevel === value
  }]));
}

/** Returns the filter options for the recent days the projects were created in */
export function getProjectsCreatedFilterPresets() {
  return getRecentDateFilterOptions(getProjectCreatedTime);
}

/** Returns the time the project was created */
function getProjectCreatedTime(project) {
  return project.createdAt;
}